import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  input,
} from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputText } from 'primeng/inputtext';
import { ForeignAddressFormModel } from './form-group/foreign-address-form.model';
import { ControlErrorDirective } from '../../../directive/control-error.directive';
import { Select } from 'primeng/select';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { SlownikRodzaj } from '../../../enums/slownik-rodzaj.enum';
import { SlownikiApi } from '../../../services/api/slowniki.api';
import { catchError, EMPTY, map, tap } from 'rxjs';
import { Slownik } from '../../../models/slownik';
import { RequiredLabelDirective } from '../../../directive/required-label.directive';
import { HttpResponseService } from '../../../../core/services/http-error-response.service';

@Component({
  selector: 'app-form-foreign-address',
  imports: [
    FormsModule,
    InputText,
    ReactiveFormsModule,
    ControlErrorDirective,
    Select,
    RequiredLabelDirective,
  ],
  templateUrl: './form-foreign-address.component.html',
  styleUrl: './form-foreign-address.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormForeignAddressComponent {
  public formGroup = input.required<FormGroup<ForeignAddressFormModel>>();
  public schoolAddress = input<boolean>(false);
  readonly #slownikiApi = inject(SlownikiApi);
  readonly #httpResponseService = inject(HttpResponseService);
  readonly #destroyRef = inject(DestroyRef);
  protected readonly panstwa = toSignal(
    this.#slownikiApi.getSlownik$(SlownikRodzaj.PANSTWA).pipe(
      map((resp: Slownik[]) =>
        resp
          .filter((value) => value.symbol !== 'PL' && value.symbol !== 'NN')
          .map(
            (value) =>
              ({
                id: value.id,
                nazwa: value.panstwo,
                kod: value.symbol,
              }) as Slownik,
          ),
      ),
      tap((panstwa: Slownik[]) => this.#validateSelectedCountry(panstwa)),
      catchError((err) => {
        this.#httpResponseService.showErrorMessage(
          err,
          'Wystąpił błąd podczas pobrania danych niezbędnych do wypełnienia formularza',
        );
        return EMPTY;
      }),
      takeUntilDestroyed(this.#destroyRef),
    ),
    { initialValue: [] },
  );

  #validateSelectedCountry(panstwa: Slownik[]) {
    const panstwoCtrl = this.formGroup().controls.panstwo;
    const findPanstwo = panstwa.find(
      (value: Slownik) => value.kod === panstwoCtrl?.value?.kod,
    );
    if (!findPanstwo) {
      panstwoCtrl?.reset();
    }
  }
}
